var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,2.616A2.616,2.616,0,0,0,17.384,0H2.616A2.616,2.616,0,0,0,0,2.616V17.383A2.616,2.616,0,0,0,2.616,20H17.383A2.616,2.616,0,0,0,20,17.384ZM4.489,16.331a.583.583,0,0,1-.714-.714l.719-2.678,2.673,2.673ZM16.035,6.591,8.123,14.5,5.462,11.842,13.374,3.93a.961.961,0,0,1,1.359,0l1.3,1.3A.961.961,0,0,1,16.035,6.591Z",
    fill: "#748195"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ca43c821cef84b042f2ac40a55fd103b.svg";
export { ForwardRef as ReactComponent };